import { render, staticRenderFns } from "./ContactInfoPanel.vue?vue&type=template&id=4430e34c&scoped=true&"
import script from "./ContactInfoPanel.vue?vue&type=script&lang=js&"
export * from "./ContactInfoPanel.vue?vue&type=script&lang=js&"
import style0 from "./ContactInfoPanel.vue?vue&type=style&index=0&id=4430e34c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4430e34c",
  null
  
)

export default component.exports